var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import ShopAfterSalesService from "../../api/ShopAfterSalesService";
import GLOBAL_VUE from '../../globalVue';
import HeaderItem from "../accountcheck/components/HeaderItem.vue";
import { Loading } from 'element-ui';
import viewImgList from './components/viewImgList';
import AddDialog from './components/GoodAdd.vue';
import { BigNumber } from "bignumber.js";
import { mapActions } from "vuex";
import Header from './components/AddHeader.vue';
var Add = (function (_super) {
    __extends(Add, _super);
    function Add() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.tableHeight = 300;
        _this.goodsTableData = [];
        _this.formData = {
            refund_order_id: '',
            images: [],
            refund_order_type: 1,
            refund_order_type_name: '',
            refund_reason: '其它',
            apply_refund_money: 0.00,
            purchase_order_order_code: '',
            creator_name: '',
            edit: true,
            remark: '',
        };
        _this.showAudit = false;
        _this.rowId = '';
        return _this;
    }
    Add.prototype.mounted = function () {
        var _this = this;
        this.getAuth("310002").then(function (pageAuth) {
            _this.showAudit = pageAuth.Auth.Handle;
            console.log(111, _this.showAudit);
        });
        setTimeout(function () {
            _this.tableHeight = document.documentElement.clientHeight - 340;
        }, 300);
    };
    Add.prototype.created = function () {
        this.service = ShopAfterSalesService.getInstance();
        if (this.rowId !== '' && this.rowId !== undefined && this.rowId !== '0') {
            this.formData.edit = false;
            this.getDetail();
        }
        if (this.keyword) {
            this.formData.keyword = this.keyword;
        }
        console.log('edit', this.formData.edit);
    };
    Add.prototype.getDetail = function () {
        var _this = this;
        var loadingInstance = Loading.service({ fullscreen: true });
        var params = {
            refund_order_id: this.rowId
        };
        this.service.getDetail(params).then(function (res) {
            loadingInstance.close();
            var data = res.data.data;
            data.refund_order_detail = data.refund_order_detail || [];
            data.refund_order_detail.forEach(function (item, index) {
                if (item.order_goods_replace && item.order_goods_replace.length !== 0) {
                    item.order_goods_replace.goods_format_name = item.order_goods_replace.supplier_goods_format;
                    item.order_goods_replace.remark = item.order_goods_replace.order_detail_icomment;
                    item.children = [item.order_goods_replace];
                }
                item.isIndex = true;
                item.parentIndex = index + 1;
            });
            _this.formData.refund_order_id = data.refund_order_id;
            _this.formData.refund_order_code = data.refund_order_code;
            _this.formData.purchase_order_order_id = data.purchase_order_order_id;
            _this.formData.purchase_order_order_code = data.order_code;
            _this.formData.business_id = data.business_id;
            _this.formData.business_name = data.business_name;
            _this.formData.supplier_to_business_id = data.supplier_to_business_id;
            _this.formData.shop_id = data.shop_id;
            _this.formData.shop_name = data.shop_name;
            _this.formData.apply_refund_money = Number(data.apply_refund_money);
            _this.formData.remark = data.remark;
            _this.formData.creator_name = data.creator_name;
            _this.formData.refund_order_type = data.refund_order_type;
            _this.formData.refund_order_type_name = data.refund_order_type_name;
            var images = [];
            data.images.forEach(function (item) {
                images.push({ url: item });
            });
            _this.formData.images = images;
            _this.goodsTableData = data.refund_order_detail;
        }).catch(function (err) {
            loadingInstance.close();
            _this.$message.error(err.message || err.msg);
        });
    };
    Add.prototype.selectionChange = function (rows) {
        this.selections = rows;
    };
    Add.prototype.validateAddGood = function (data) {
        if (!data.purchase_order_order_id) {
            throw new Error('请选择订货单');
        }
        return false;
    };
    Add.prototype.addGoods = function () {
        var _this = this;
        console.log(111, this.formData);
        try {
            this.validateAddGood(this.formData);
        }
        catch (err) {
            this.$message.warning(err.message);
            return;
        }
        var goodIds = [];
        this.goodsTableData.forEach(function (item) {
            goodIds.push(item.goods_format_id);
        });
        var instance = this.$dialog(AddDialog, {
            data: {
                formData: this.formData,
                addedDatas: this.goodsTableData,
                selectedGoodIds: goodIds,
            },
        }, {
            title: '请选择退货货品（' + this.formData.purchase_order_order_code + '）',
            width: 900,
            height: 550,
        }).instance;
        instance.$on('submit', function (selectGood) {
            if (selectGood.length) {
                console.log(222, selectGood, goodIds);
                selectGood.forEach(function (item) {
                    if (goodIds.indexOf(item.goods_format_id) !== -1) {
                        return;
                    }
                    item.refund_money = 0;
                    _this.goodsTableData.push(item);
                });
            }
        });
    };
    Add.prototype.deleteGood = function () {
        var _this = this;
        if (!this.selections || !this.selections.length) {
            this.$message.warning('请选择货品');
            return;
        }
        this.$confirm('请确认是否删除该货品', '提示').then(function (res) {
            _this.selections.forEach(function (item) {
                var index = _this.goodsTableData.indexOf(item);
                _this.goodsTableData.splice(index, 1);
            });
        }, function (err) { });
    };
    Add.prototype.save = function (refund_order_status) {
        var _this = this;
        if (refund_order_status === void 0) { refund_order_status = 1; }
        var params = {
            refund_order_status: refund_order_status,
        };
        params = Object.assign(params, this.formData, { goods_list: this.goodsTableData });
        params.order_code = params.purchase_order_order_code;
        console.log(123, params);
        if (this.goodsTableData.length === 0) {
            this.$message.warning('请添加退货货品');
            return;
        }
        var isTrue = false;
        params.goods_list.forEach(function (item) {
            if (item.refund_amount > 0 || item.refund_gift_amount > 0) {
                isTrue = true;
            }
            if (!item.refund_amount) {
                item.refund_amount = 0;
            }
            if (!item.refund_gift_amount) {
                item.refund_gift_amount = 0;
            }
        });
        if (!isTrue) {
            this.$message.warning('采购退货量，赠品退货量，至少一个大于0');
            return;
        }
        if (params.images) {
            var images_1 = [];
            params.images.forEach(function (item) {
                images_1.push(item.url);
                console.log(111, item);
            });
            params.images = images_1.join(',');
        }
        console.log('save===>', params);
        var loadingInstance = Loading.service({ fullscreen: true });
        this.service.saveRefundOrde(params).then(function (res) {
            console.log(111, res.data.code);
            if (0 === res.data.code) {
                loadingInstance.close();
                _this.$message.success('保存成功');
                setTimeout(function () {
                    _this.opener.search(_this.openerFilter);
                    GLOBAL_VUE.$emit("closeTab", _this);
                }, 1000);
            }
            else {
                loadingInstance.close();
                _this.$message.error(res.data.msg || res.data.message);
            }
        }).catch(function (err) {
            loadingInstance.close();
            _this.$message.error(err.message || err.msg);
        });
    };
    Add.prototype.inputChange = function (row, key) {
        var _this = this;
        if (row[key]) {
            var value = row[key];
            if (value.indexOf('.') === 0) {
                value = '0' + value;
            }
            value = value.replace(/。/g, '.');
            value = value.replace(/[^\d.]/g, '');
            var dotIndex = value.indexOf('.');
            if (dotIndex !== -1) {
                var decimalPart = value.substring(dotIndex + 1).replace(/\./g, '');
                value = value.substring(0, dotIndex + 1) + decimalPart.substring(0, 2);
            }
            if ('refund_amount' == key && row.max_detail_refund_amount < value) {
                value = row.max_detail_refund_amount;
            }
            if ('refund_gift_amount' == key && row.max_gift_refund_amount < value) {
                value = row.max_gift_refund_amount;
            }
            row[key] = value;
            if ('refund_amount' === key) {
                row.refund_money = this.myFixed((row.refund_amount * row.order_detail_uprice), 2);
                this.formData.apply_refund_money = 0;
                this.goodsTableData.forEach(function (item) {
                    console.log(123, Number(_this.formData.apply_refund_money) + Number(item.refund_money));
                    _this.formData.apply_refund_money = _this.myFixed((Number(_this.formData.apply_refund_money) + Number(item.refund_money)), 2);
                });
                console.log(456, this.formData.apply_refund_money);
            }
            if ('refund_money' === key) {
                row.refund_amount = this.myFixed((row.refund_money / row.order_detail_uprice), 2);
                if (row.refund_amount > row.max_detail_refund_amount) {
                    row.refund_amount = row.max_detail_refund_amount;
                    row.refund_money = this.myFixed((row.refund_amount * row.order_detail_uprice), 2);
                }
                this.formData.apply_refund_money = 0;
                this.goodsTableData.forEach(function (item) {
                    _this.formData.apply_refund_money = _this.myFixed((Number(_this.formData.apply_refund_money) + Number(item.refund_money)), 2);
                });
            }
        }
    };
    Add.prototype.myFixed = function (num, digit) {
        return BigNumber(num).toFixed(digit);
    };
    Add.prototype.emptyData = function () {
        this.goodsTableData = [];
    };
    Add = __decorate([
        Component({
            components: {
                HeaderItem: HeaderItem,
                viewImgList: viewImgList,
                'add-header': Header,
            },
            computed: {
                isInputDisable: function () {
                    return this.formData.refund_order_type === 2 || this.formData.refund_order_type === 4;
                }
            },
            methods: __assign({}, mapActions(["updateMenuList", "getAuth"])),
        })
    ], Add);
    return Add;
}(Vue));
export default Add;
